export { curveBasis, curveBasisClosed, curveBasisOpen, curveStep, curveStepAfter, curveStepBefore, curveBundle, curveLinear, curveLinearClosed, curveCardinal, curveCardinalClosed, curveCardinalOpen, curveCatmullRom, curveCatmullRomClosed, curveCatmullRomOpen, curveMonotoneX, curveMonotoneY, curveNatural } from 'd3-shape';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/curve/dist/vx-curve.es.js
// module id = 221
// module chunks = 0